// Textfelder aus der Datenbank sind nicht immer Text.
//
// Ein Excel-Import liefert Zahlen als Zahlen, eine Schnittstelle kann ein
// Objekt hineinschreiben — und ein einziger solcher Datensatz hat die ganze
// Leadliste weiss gemacht ("n.charAt is not a function"), weil `name?.charAt`
// nur gegen null schuetzt, nicht gegen den falschen Typ. Alles, was gerendert
// wird, laeuft deshalb hier durch.

/** Beliebigen Wert als Text — null/undefined leer, Objekte lesbar statt "[object Object]". */
export function alsText(v) {
  if (v === null || v === undefined) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  if (Array.isArray(v)) return v.map(alsText).filter(Boolean).join(', ');
  if (typeof v === 'object') {
    // Bevorzugt ein Namensfeld, sonst die Werte — Hauptsache kein Absturz
    for (const k of ['name', 'label', 'titel', 'title', 'vorname']) {
      if (typeof v[k] === 'string') return v[k];
    }
    return Object.values(v).map(alsText).filter(Boolean).join(' ');
  }
  return String(v);
}

/** "neuer_lead" -> "Neuer Lead"; vertraegt jeden Eingabetyp. */
export function toTitleCase(v) {
  const s = alsText(v);
  return s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Erster Buchstabe fuer den Avatar-Kreis — nie ein Absturz, notfalls leer. */
export function initial(v) {
  return alsText(v).trim().charAt(0).toUpperCase();
}

/** Naechster Schritt am Lead: frueher ein Text, seit dem Vertriebssystem v5 ein
 *  Objekt {was, faellig_am, wer} (Angebot, Sommerfest-Scan, Stage-Wechsel).
 *  Ein einziger solcher Lead hat die Pipeline mit React-Fehler #31 abgeschossen. */
export function schrittText(v) {
  if (v && typeof v === 'object' && !Array.isArray(v) && typeof v.was === 'string') {
    let bis = '';
    if (v.faellig_am) {
      const d = new Date(v.faellig_am);
      if (!Number.isNaN(d.getTime())) bis = ` · bis ${d.toLocaleDateString('de-DE')}`;
    }
    return `${v.was}${bis}`;
  }
  return alsText(v);
}
